import { useI18n } from 'domains/i18n/hooks'
import { className } from 'lib/css'
import Icon from 'ui/components/layout/icon'

export default function CarouselControls({
  items,
  currentIndex,
  onChange,
  children,
}) {
  const { t } = useI18n()
  const itemCount = items.length
  const handlePrevious = () => {
    onChange((currentIndex - 1 + itemCount) % itemCount)
  }
  const handleNext = () => {
    onChange((currentIndex + 1) % itemCount)
  }

  return (
    <div className={className('carousel-controls')}>
      <button
        className={className('button', 'button--previous')}
        aria-label={t('carousel.controls.previous')}
        onClick={handlePrevious}
      >
        <Icon name="arrowLeft" size="16" alt="" />
      </button>
      {children}
      <button
        className={className('button', 'button--next')}
        aria-label={t('carousel.controls.next')}
        onClick={handleNext}
      >
        <Icon name="arrowRight" size="16" alt="" />
      </button>
    </div>
  )
}
